
import SkeletonMap from "../../components/skeleton/Map.vue";
import MapItem from "../../components/map/index.vue";
import FrameService from "../../src/FrameService";
import ItemListFilter from "../../components/Filter/index.vue";
import { Api } from "../../src/Api";
import PreviewCard from "../../components/Card/PreviewCard/index.vue";
import { CupertinoPane } from "cupertino-pane";
import { PageIdentity } from "../../src/Entity/Page";
import { PropType } from "vue";
import { v4 as uuid } from 'uuid';
import { Filters } from "modules/spravochnik/dt-front-page-generator/src/Entity/Filter";
import { UrlService } from "modules/spravochnik/dt-front-page-generator/src/Service/Url/UrlService";

export default {
    props: {
        pageIdentity: {
            type: Object as PropType<PageIdentity>,
            required: true,
        },
    },
    components: {
        SkeletonMap,
        MapItem,
        ItemListFilter,
        PreviewCard,
    },
    created() {
        (new FrameService()).offFooter().off();
    },
    async mounted() {
        this.loadingPage = true;
        await this.$store.dispatch("page/loadPageByIdentity", this.pageIdentity);
        this.page = this.$store.getters['page/page'];
        this.urlService = new UrlService(this.$router, this.page, this.pageNumber).updateEntity().apply();
        this.loadingPage = false;

        await this.loadMapObjects();
    },
    async unmounted() {
        this.page.filters.reset();
    },
    watch: {
        page: {
            handler(newValue, oldValue) {
                if (oldValue) {
                    this.drawer = new CupertinoPane(".cupertino-pane", this.settings);
                    setTimeout(() => this.drawer.present({ animate: true }));
                }
            },
            deep: true,
        },
    },
    methods: {
        filterable(value) {
            this.filter = value;
        },
        async loadMapObjects() {
            this.loadingMapObjects = true;
            const objects = await Api.fetchMapObjectByPage(this.page);
            this.mapKey = uuid();
            this.objects = objects;
            this.loadingMapObjects = false;
        },
        async onChoiceElem(ids: string[]) {
            this.loading = true;
            this.items = await Api.fetchPageItemByIds(this.page, ids);
            this.loading = false;
            this.showPageItemCards = true;
            this.drawer?.moveToBreak("top");
        },
        onHideCupertino(): void {
            this.drawer.hide();
        },
        async onApplyFilter(filters: Filters) {
            this.urlService.apply();
            await this.loadMapObjects();
        },
        async onResetFilter() {
            this.urlService.apply();
            await this.loadMapObjects();
        },
    },
    data() {
        return {
            page: null,
            showPageItemCards: false,
            filter: null,
            mapKey: uuid(),
            objects: [],
            items: [],
            selectedObjectIds: [] as string[],
            loading: false,
            loadingPage: true,
            loadingMapObjects: false,
            drawer: null,
            urlService: null,
            settings: {
                "initialBreak": "bottom",
                breaks: {
                    top: { "enabled": true, "height": 700 },
                    middle: { "enabled": true, "height": 400 },
                    bottom: { "enabled": true, "height": 0 },
                },
            },
        };
    },
};
